module.exports = __webpack_public_path__ + "img/LOGO DOWNLOAD-04.ff346232.png";